import { render } from "./HeroiconsSolidLink.vue?vue&type=template&id=669b496b"
const script = {}

import exportComponent from "/web/markle/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidLink.vue"]])

export default __exports__